// @flow
import $ from 'jquery';
import axios from 'axios';
import card from 'card';

const creditCardForm = '#creditCardForm';
const creditCardPlaceholder = $('#credit-card-placeholder');

function sendForm() {
    const cardForm = $(creditCardForm);
    cardForm.submit(function (e) {
        $.ajax({
            type: 'POST',
            url: cardForm.attr('action'),
            data: cardForm.serialize(),
            success: function (data) {
               console.log(data);
            },
        });
        e.preventDefault();
    });
}

function init() {
    if ($('#creditCardForm').length) {
        const cardForm = new Card({
            form: creditCardForm,
            container: '.card-placeholder',
            formSelectors: {
                numberInput: 'input#credit_card_number',
                expiryInput: 'input#credit_card_expiration',
                cvcInput: 'input#credit_card_ccv',
                nameInput: 'input#credit_card_holder',
            },
            width: 350, // optional — default 350px
            formatting: true, // optional - default true
            messages: {
                validDate: 'valid\ndate', // optional - default 'valid\nthru'
                monthYear: 'mm/yyyy', // optional - default 'month/year'
            },
            placeholders: {
                number: creditCardPlaceholder.data('number'),
                name: creditCardPlaceholder.data('holder'),
                expiry: creditCardPlaceholder.data('expiration'),
                cvc: '...',
            },
            debug: false // optional - default false
        });
    }
}

export { init };



// WEBPACK FOOTER //
// ./src/_app/layout/payform.js